// extracted by mini-css-extract-plugin
export default {"header":"FileUpload--header--cb94bd","description":"FileUpload--description--52c339","buttonWrapper":"FileUpload--buttonWrapper--cfa997","fileName":"FileUpload--fileName--5e9bd7"};